import './Header.css'
export const Header = () => {
    return (
        <div className="saludo">
              <h1>"Librería Melquíades"</h1>
        </div>
    );
}

